import { z } from "zod";
import { SCALE_FACTORS } from "../../../Board/constants.ts";
import { UPSCALE_IMAGINATION_STRENGTH_PRESETS } from "../../../Board/Workspaces/EditWorkspace/Tools/EditAsset/Upscale/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

export const DEFAULT_UPSCALE_CREATIVITY = 0.5;
export const DEFAULT_UPSCALE_RESEMBLANCE = 0.5;

const zUpscaleSettings = z.object({
  prompt: z.string().default(""),
  resemblance: z.number().default(DEFAULT_UPSCALE_RESEMBLANCE),
  creativity: z.number().default(DEFAULT_UPSCALE_CREATIVITY),
  negative_prompt: z.string().default(""),
  num_outputs: z.number().default(1),
  scale_factor: z.enum(SCALE_FACTORS).default("2"),
  imagination_strength_preset: z
    .enum(UPSCALE_IMAGINATION_STRENGTH_PRESETS)
    .default("MEDIUM"),
});

export const upscaleSettingsStorage = settingsStorageFactory(
  "upscale-settings",
  2,
  zUpscaleSettings,
);
